export function normalizeZipCode(zipCode: string | null | undefined): string | null {
  return zipCode?.replace(/[^0-9]/g, '') || null;
}
